export const filelist = [
    {
        name: "Informationsschreiben",
        path: "/documents/20251216/1_Informationsschreiben.pdf"
    },
    {
        name: "Lohntabelle 2026",
        path: "/documents/20251216/2_Lohntabelle_2026.pdf"
    },
    {
        name: "Steuersatzmeldung 2026",
        path: "/documents/20251216/3_Steuersatzmeldung_2026.pdf"
    },
    {
        name: "Steuersatzmeldung 2026 - Word",
        path: "/documents/20251216/4_Steuersatzmeldung_2026.docx"
    },
    {
        name: "Katholikenzahlmeldung",
        path: "/documents/20251216/5_Katholikenzahlmeldung.pdf"
    },
    {
        name: "Katholikenzahlmeldung - Word",
        path: "/documents/20251216/6_Katholikenzahlmeldung.docx"
    },
    {
        name: "Wiedereintritt - Formular",
        path: "/documents/20251216/7_Wiedereintritt_-_Formular.pdf"
    },
    {
        name: "Wiedereintritt - Formular - Word",
        path: "/documents/20251216/8_Wiedereintritt_-_Formular.docx"
    },
]